<template>
  <div>
    <div>
      <div v-for="blockData in blocksData" :key="blockData?.id">
        <GenericBlock
          :component-type="blockData.__typename"
          :content="blockData"
          @open-contact-form="(plan) => handlePricingOptionClick(plan)"
          @open-case-study-form="openCaseStudyForm"
        />
      </div>
    </div>
    <client-only>
      <ErrorBoundary>
        <ContactForm
          ref="contactForm"
          :is-open="isOpen"
          :script-inner-html="`hbspt.forms.create({region:'eu1',portalId:'25031492',formId:'d67698fd-ed1d-42ad-b960-702f4af8be93', onFormReady: (form) => { form.querySelector('[name=plan_type]').value= '${pricingOptionClicked}' }});`"
          @click:close-dialog="closeContactForm"
        />
        <ContactForm
          ref="caseStudyForm"
          :is-open="isCaseStudyModalOpen"
          :script-inner-html="'hbspt.forms.create({region:\'eu1\',portalId:\'25031492\',formId:\'dba4cd67-fb89-498a-9aeb-529b9edb96b2\'});'"
          @click:close-dialog="closeCaseStudyForm"
        />
      </ErrorBoundary>
    </client-only>
  </div>
</template>

<script setup>
import { useStrapiPageSeo } from '~/composables/useStrapiPage'
const { t, locale } = useI18n()
const bannerDefaults = {
  title: t('partner.header.title'),
  description: t('partner.header.description'),
  ctaText: t('partner.header.buttonLabel'),
}

const pageData = await useStrapiPage({
  slug: `partner_${locale.value}`,
  locale: convertLocaleIntoBCP47(locale.value),
})
const blocksData = computed(() => pageData?.data?.value?.pages?.[0]?.contents)
definePageMeta({
  layout: 'default-max-screen',
  preloaderType: 'strapi',
})
const caseStudyForm = ref(null)
const isCaseStudyModalOpen = ref(false)
const openCaseStudyForm = () => {
  isCaseStudyModalOpen.value = true
  caseStudyForm.value?.init()
}
const closeCaseStudyForm = () => {
  isCaseStudyModalOpen.value = false
}
useStrapiPageSeo({
  pageData,
})
</script>

<style scoped>
@screen md {
  .form-section iframe {
    min-height: 625px;
  }
}

@media (-webkit-device-pixel-ratio: 1.1) {
  .form-section {
    zoom: 1.1;
  }
}

@media (-webkit-device-pixel-ratio: 1.25) {
  .form-section {
    zoom: 1.25;
  }
}

@media (-webkit-device-pixel-ratio: 1.5) {
  .form-section {
    zoom: 1.5;
  }
}
</style>
